import apiClient from './client';

export interface Device {
  id: string;
  hardwareId: string;
  name?: string;
  hostname?: string;
  platform?: string;
  status: 'ACTIVE' | 'INACTIVE' | 'REGISTERED' | 'DEACTIVATED';
  licenseId?: string | null;
  username?: string;
  createdAt: string;
  lastHeartbeat?: string | null;
  lastOnlineAt?: string | null;
  metadata?: Record<string, any>;
}

export interface HeartbeatResponse {
  deviceId: string;
  status: string;
  lastHeartbeat: string;
  lastOnlineAt: string;
}

export const deviceService = {
  getDevices: async (): Promise<Device[]> => {
    const response = await apiClient.get<Device[]>('/devices');
    return response.data;
  },

  getDevice: async (id: string): Promise<Device> => {
    const response = await apiClient.get<Device>(`/devices/${id}`);
    return response.data;
  },

  sendHeartbeat: async (deviceId: string, metadata?: Record<string, any>): Promise<HeartbeatResponse> => {
    const response = await apiClient.post<HeartbeatResponse>(
      `/devices/${deviceId}/heartbeat`,
      { metadata }
    );
    return response.data;
  },

  activateDevice: async (deviceId: string, licenseId: string, metadata?: Record<string, any>): Promise<Device> => {
    const response = await apiClient.post<Device>(
      `/devices/${deviceId}/activate`,
      { license_id: licenseId, metadata }
    );
    return response.data;
  },

  deactivateDevice: async (deviceId: string, metadata?: Record<string, any>): Promise<Device> => {
    const response = await apiClient.post<Device>(
      `/devices/${deviceId}/deactivate`,
      { metadata }
    );
    return response.data;
  },

  blockDevice: async (id: string): Promise<void> => {
    await apiClient.post(`/devices/${id}/block`);
  },

  unblockDevice: async (id: string): Promise<void> => {
    await apiClient.post(`/devices/${id}/unblock`);
  },

  deleteDevice: async (id: string): Promise<void> => {
    await apiClient.delete(`/devices/${id}`);
  }
};

// 後方互換性のためのエクスポート
export const getDevices = deviceService.getDevices;
export const getDevice = deviceService.getDevice;
export const blockDevice = deviceService.blockDevice;
export const unblockDevice = deviceService.unblockDevice; 